export default {"src":"/_next/static/media/impact_dw_logo.aec8e688.svg","height":63,"width":245,"blurWidth":0,"blurHeight":0};